import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';

@Component({
  selector: 'app-rich-text-editor',
  standalone: true,
  imports: [EditorModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichTextEditorComponent),
      multi: true
    }
  ],
  template: `
    <p-editor 
      [style]="{ height: height }"
      [(ngModel)]="value"
      (ngModelChange)="onValueChange($event)"
      (onBlur)="handleBlur()">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-italic" aria-label="Italic"></button>
          <button type="button" class="ql-underline" aria-label="Underline"></button>
          <button type="button" class="ql-strike" aria-label="Strike"></button>
          <button type="button" class="ql-header" value="1" aria-label="Heading 1"></button>
          <button type="button" class="ql-header" value="2" aria-label="Heading 2"></button>
          <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
          <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
          <button type="button" class="ql-indent" value="-1" aria-label="Outdent"></button>
          <button type="button" class="ql-indent" value="+1" aria-label="Indent"></button>
          <button type="button" class="ql-direction" value="rtl" aria-label="Text Direction"></button>
          <button type="button" class="ql-clean" aria-label="Clean"></button>
        </span>
      </ng-template>
    </p-editor>
  `
})
export class RichTextEditorComponent implements ControlValueAccessor {
  @Input() height: string = '320px';
  
  value: string = '';
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Handle disabled state if needed
  }

  onValueChange(value: string): void {
    this.value = value;
    this.onChange(value);
  }

  handleBlur(): void {
    this.onTouched();
  }
} 